import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Marker, MapContext } from 'react-mapbox-gl';
import type { Coordinates } from '@lt/api/dist/types/map';

import { pulseAnimation } from './styles';
import { adjustMapPosition } from '../../utils';

interface ActiveHotelProps {
  coordinates: Coordinates;
  isHotelCardOpened: boolean;
}

/**
 * При наведении на карточку отеля, карта центрируется на выбранном отеле
 */
export const ActiveHotel = (props: ActiveHotelProps) => {
  const map = useContext(MapContext);
  const { coordinates, isHotelCardOpened } = props;

  useEffect(() => {
    if (!map) return;

    adjustMapPosition(map, coordinates, {
      zoom: isHotelCardOpened ? map.getZoom() : 14,
      offset: [0, isHotelCardOpened ? -200 : 0],
    });
  }, [map, coordinates, isHotelCardOpened]);

  return <ActiveHotelMarker anchor="center" coordinates={coordinates} />;
};

const ActiveHotelMarker = styled(Marker)`
  width: 24px;
  height: 24px;
  background: linear-gradient(0deg, #007aff 0%, #2180ff 97.15%);
  border: solid 1px #fff;
  border-radius: 50%;
  cursor: pointer;
  pointer-events: none;
  :after,
  :before {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 50%;
    animation: ${pulseAnimation} 1.5s linear infinite;
  }
  :after {
    animation-delay: 0.4s;
  }
`;
